import { all } from 'redux-saga/effects'

import { globalSagas } from './global/sagas'
import { accountSagas } from './account/sagas'
import { newUserWizardSagas } from './wizardNewUser/sagas'
import { spareAxleRequestSagas } from './wizardSpareAxleRequest/sagas'

export function* rootSaga() {
  try {
    yield all([
      // add saga entrypoints here
      // the entrypoints should then use fork to add all necessary watchers
      globalSagas(),
      accountSagas(),
      newUserWizardSagas(),
      spareAxleRequestSagas(),
    ])
  } catch (e) {
    console.error('ERROR in root.saga:', e)
  }
}
